import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import KanbanBoardIndex from './pages/KanbanBoardIndex.vue';

// DEBT customization — T3.4 página do board. Autorização declarada SÓ aqui,
// no meta da rota (precedente: debt_state_governance, reports.routes.js) —
// Sidebar.vue já resolve permissions/featureFlag a partir do meta da rota
// resolvida (SidebarGroup#isAllowed, components-next/sidebar/provider.js),
// então não há checagem duplicada no componente nem no menu.
//
// permissions usa a lista explícita (não CONVERSATION_PERMISSIONS): a
// policy do backend (DebtKanbanPolicy) libera QUALQUER account_user da
// conta, sem exigir nenhuma permissão granular — 'custom_role' sozinho (sem
// compor com conversation_manage e afins) é o que espelha isso no front.
const KANBAN_BOARD_PERMISSIONS = ['administrator', 'agent', 'custom_role'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_board',
    component: KanbanBoardIndex,
    meta: {
      featureFlag: FEATURE_FLAGS.DEBT_KANBAN_BOARD,
      permissions: KANBAN_BOARD_PERMISSIONS,
    },
  },
];
